import PropTypes from 'prop-types';
import React from 'react';
import { withLabels } from '../../../utils/LabelsContext';
import Alert from '../../ui/Alert/Alert';
import { AvailabilityMobileStyles } from './AvailabilityMobile.style';

const AvailabilityMobileItemDownloadable = ({ labels }) => {
  return (
    <>
      <div className="availability-item">
        <div className="content downloadAvailable" id="testId-Availability-Desktop-ModalOpen-downloadAvailable">
          <Alert content={() => labels.AVAILABILITY_DOWNLOADABLE} toggleState={{ visible: true }} type="info" />
        </div>
      </div>
      <style jsx>{AvailabilityMobileStyles}</style>
    </>
  );
};

AvailabilityMobileItemDownloadable.propTypes = {
  labels: PropTypes.object,
};

AvailabilityMobileItemDownloadable.defaultProps = {
  labels: {},
};

export { AvailabilityMobileItemDownloadable };
export default withLabels(AvailabilityMobileItemDownloadable);
